module.exports = __webpack_public_path__ + "img/default-room.b52d24bd.jpg";